import { render, staticRenderFns } from "./EmailVerifyButton.vue?vue&type=template&id=336313bf&scoped=true&lang=pug"
import script from "./EmailVerifyButton.vue?vue&type=script&lang=ts"
export * from "./EmailVerifyButton.vue?vue&type=script&lang=ts"
import style0 from "./EmailVerifyButton.vue?vue&type=style&index=0&id=336313bf&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "336313bf",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VIcon})
